import React from "react";
import image from "./News.webp";

const NewsItem = (props) => {
  let { title, description, imageUrl, newsUrl, date } = props;
  return (
    <div>
      <div className="card">
        <div></div>
        <img
          src={imageUrl === " " ? `${image}` : imageUrl}
          className="card-img-top"
          alt="nhi. ah ha ha ha ha..."
        />
        <div className="card-body">
          <h5 className="card-title">{title}</h5>
          <p className="card-text">{description}...</p>
          <p className="card-text">
            <small className="text-muted">
              Published on {new Date(date).toGMTString()}
            </small>
          </p>
          <a
            href={newsUrl}
            target="_blank"
            rel="noreferrer"
            className="btn btn-dark btn-sm"
          >
            Read More...
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewsItem;
// newUrl : To do
